import { render, staticRenderFns } from "./add-department.vue?vue&type=template&id=0e83deb7&scoped=true"
import script from "./add-department.ts?vue&type=script&lang=ts&external"
export * from "./add-department.ts?vue&type=script&lang=ts&external"
import style0 from "./add-department.scoped.scss?vue&type=style&index=0&id=0e83deb7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e83deb7",
  null
  
)

export default component.exports